import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const handleError = (error, signOut, navigate) => {
  const status = error?.response?.status || error?.status;

  const message =
    error?.response?.data?.message || error.message || error?.data?.message || 'An unknown error occurred';

  // Network or unexpected errors (like CORS, timeout, offline)
  //   if (!error.response) {
  //     toast.error('Network error. Please check your internet connection.', {
  //       position: 'top-center',
  //     });
  //     return;
  //   }

  switch (status) {
    case 403:
      toast.error(message, { position: 'top-center' });
      // Optional: Handle token expiry or permission issues
      break;

    case 404:
      toast.error('The requested resource was not found.', {
        position: 'top-center',
      });

      // Optional: Redirect to a "Not Found" page
      // navigate('/404');
      break;
    case 400:
      toast.error(message, { position: 'top-center' });
      // navigate('/');
      break;
    case 407:
      toast.error(message, { position: 'top-center' });
      setTimeout(() => {
        signOut();
      }, 1000);
      break;
    case 401:
      toast.error(message, { position: 'top-center' });
      setTimeout(() => {
        signOut();
      }, 1000);
      break;

    default:
      toast.error(message, { position: 'top-center' });
      break;
  }
};
